import cx from 'classnames';
import { useGetUserFullName } from 'hooks/useGetUserFullName';
import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';
import { PurposeStatusBadge } from 'pages/approvals/views/PurposeStatusBadge';
import { ChatDots, ChevronRight } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { StringParam, useQueryParam } from 'use-query-params';

/**
 * @param {import('models/approval.models').ApprovalItem} approvalItem
 * @param {import('models/approval.models').ApprovalParticipation} participation
 */
export function ParticipationRow({ approvalItem, participation }) {
    const { t, i18n } = useTranslation();
    const createdBy = useGetUserFullName(participation.userId, false);
    const [approvalParticipationId, setApprovalParticipation] = useQueryParam('ap', StringParam);
    const [, setApprovalItem] = useQueryParam('ai', StringParam);

    const isDisabled = participation.action !== 'approved';
    const isActive = participation.action === 'approved' && approvalParticipationId === participation.id;

    return (
        <button
            type="button"
            className={cx('btn btn-row flex-center py-2 px-1 pr-3 justify-content-between', {
                active: isActive,
            })}
            onClick={() => {
                setApprovalItem(undefined);
                setApprovalParticipation(participation.id);
            }}
            disabled={isDisabled}
            style={{ borderRadius: 0 }}
        >
            <div>
                <div className="flex-center font-weight-bolder">
                    {createdBy}
                    {!isEmpty(participation.comment) && (
                        <ChatDots
                            size="12"
                            className="ml-1 mb-2 cursor-help"
                            data-uk-tooltip={t('ai:participation.hasCommentTooltip')}
                        />
                    )}
                </div>

                <PurposeStatusBadge
                    completed={participation.action === 'completed' || participation.action === 'approved'}
                    purpose={approvalItem.purpose}
                    tooltip={getBadgeTooltip()}
                    role={participation.role}
                />
            </div>

            {!isActive && <ChevronRight className="chevron mr-0" />}
        </button>
    );

    function getBadgeTooltip() {
        if (!participation.actedAt) {
            return undefined;
        }

        const actedAt = DateTime.fromISO(participation.actedAt).setLocale(i18n.language);

        return `title: ${actedAt.toLocaleString(DateTime.DATETIME_MED)}`;
    }
}
